import React from "react";
import { Element } from "react-scroll";

const Education = () => {
  return (
    <Element
      name="education"
      class="pr-[20px] pl-[20px] sm:pr-[50px] sm:pl-[50px] pt-3 pb-3 flex flex-col gap-10 items-center justify-center self-stretch shrink-0 relative"
    >
      <div class="self-stretch shrink-0 sm:h-[5px] md:h-[10px] lg:h-[20px] xl:h-[32px] relative">
        <div class="text-[#006400] text-left font-['JejuGothic-Regular',_sans-serif]  text-2xl sm:text-4xl md:text-4xl lg:text-5xl xl:text-6xl font-normal absolute flex items-center justify-start">
          Education
        </div>
      </div>
      <div class="flex flex-col gap-2.5 items-start justify-start self-stretch shrink-0 relative">
        <div class="flex flex-row gap-2.5 items-center justify-end shrink-0 w-[1101px] relative">
          <div
            class="text-[#919191] text-left font-['Inter-Regular',_sans-serif]  sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
            font-normal relative flex-1"
          >
            This is my educations and courses for now
          </div>
        </div>
      </div>
      <div class="pt-5 pb-5 flex flex-col gap-0 items-center justify-start self-stretch shrink-0 relative">
        <div class="flex flex-row items-start justify-between self-stretch shrink-0 relative">
          <div class="p-2.5 flex flex-row items-center justify-between self-stretch flex-1 relative">
            <div class="sm:pt-5 sm:pr-[30px] sm:pb-5 sm:pl-[30px] flex flex-col gap-2.5 items-center justify-center flex-1 relative">
              <div class="flex flex-col gap-[5px] sm:gap-[30px] items-center justify-center self-stretch shrink-0 relative">
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                  font-normal relative self-stretch"
                >
                  University of Pitesti
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif]  text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                  font-normal relative"
                >
                  Sep 2023 - Present
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif]  text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 
                  font-normal relative self-stretch"
                >
                  Master&#039;s degree Computer Science
                </div>
                <div class="shrink-0 w-[45px] h-[45px] relative overflow-hidden">
                  <a href="https://www.upit.ro/ro/academia-reorganizata/facultatea-de-stiinte-educatie-fizica-si-informatica/departamente-la-nivelul-facultatii-de-stiinte-educatie-fizica-si-informatica/departamentul-matematica-informatica2/mastere-departamentul-matematica-informatica2/tehnici-avansate-pentru-prelucrarea-informatiei">
                    <svg
                      class="w-[50%] h-[50%] sm:w-[90%] sm:h-[90%] absolute right-[5%] left-[5%] bottom-[4.17%] top-[4.17%] overflow-visible"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M41.25 17.2852C41.25 30.4102 21 41.6602 21 41.6602C21 41.6602 0.75 30.4102 0.75 17.2852C0.75 12.8096 2.88348 8.51741 6.68109 5.35273C10.4787 2.18805 15.6294 0.410156 21 0.410156C26.3706 0.410156 31.5213 2.18805 35.3189 5.35273C39.1165 8.51741 41.25 12.8096 41.25 17.2852Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 22.9102C24.7279 22.9102 27.75 20.3918 27.75 17.2852C27.75 14.1786 24.7279 11.6602 21 11.6602C17.2721 11.6602 14.25 14.1786 14.25 17.2852C14.25 20.3918 17.2721 22.9102 21 22.9102Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="border-dashed border-[#006400] border-2 sm:border-4 self-stretch shrink-0 w-0 relative"></div>
          <div class="p-2.5 flex flex-row gap-[150px] items-center justify-center self-stretch flex-1 relative"></div>
        </div>
        <div class="flex flex-row items-start justify-between self-stretch shrink-0 relative">
          <div class="p-2.5 flex flex-col justify-between w-10 items-center justify-center self-stretch flex-1 relative">
            <div class="sm:pt-5 sm:pr-[30px] sm:pb-5 sm:pl-[30px] flex flex-col gap-2.5 items-center justify-center shrink-0 relative">
              <div class="flex flex-col gap-[5px] sm:gap-[30px] items-center justify-center self-stretch shrink-0 relative">
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 
                  font-normal relative self-stretch"
                >
                  Vilnius University
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                  font-normal relative"
                >
                  Sep 2021 - Feb 2022
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 
                  font-normal relative self-stretch"
                >
                  Erasmus+
                </div>
                <div class="shrink-0 w-[45px] h-[45px] relative overflow-hidden">
                  <a href="https://www.vu.lt/en/">
                    <svg
                      class="w-[50%] h-[50%] sm:w-[90%] sm:h-[90%] absolute right-[5%] left-[5%] bottom-[4.17%] top-[4.17%] overflow-visible"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M41.25 17.2852C41.25 30.4102 21 41.6602 21 41.6602C21 41.6602 0.75 30.4102 0.75 17.2852C0.75 12.8096 2.88348 8.51741 6.68109 5.35273C10.4787 2.18805 15.6294 0.410156 21 0.410156C26.3706 0.410156 31.5213 2.18805 35.3189 5.35273C39.1165 8.51741 41.25 12.8096 41.25 17.2852Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 22.9102C24.7279 22.9102 27.75 20.3918 27.75 17.2852C27.75 14.1786 24.7279 11.6602 21 11.6602C17.2721 11.6602 14.25 14.1786 14.25 17.2852C14.25 20.3918 17.2721 22.9102 21 22.9102Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="sm:pt-5 sm:pr-[30px] sm:pb-5 sm:pl-[30px] flex flex-col gap-2.5 items-center justify-center shrink-0 relative">
              <div class="flex flex-col gap-[5px] sm:gap-[30px] items-center justify-center self-stretch shrink-0 relative">
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                 font-normal relative"
                >
                  University of Pitesti
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                 font-normal relative"
                >
                  Sep 2020 - Jul 2023
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                 font-normal relative self-stretch"
                >
                  Bachelor&#039;s degree Computer Science
                </div>
                <div class="shrink-0 w-[45px] h-[45px] relative overflow-hidden">
                  <a href="https://www.upit.ro/ro/academia-reorganizata/facultatea-de-stiinte-educatie-fizica-si-informatica/departamente-la-nivelul-facultatii-de-stiinte-educatie-fizica-si-informatica/departamentul-matematica-informatica2/licente-departamentul-matematica-informatica2/informatica2">
                    <svg
                      class="w-[50%] h-[50%] sm:w-[90%] sm:h-[90%] absolute right-[5%] left-[5%] bottom-[4.17%] top-[4.17%] overflow-visible"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M41.25 17.2852C41.25 30.4102 21 41.6602 21 41.6602C21 41.6602 0.75 30.4102 0.75 17.2852C0.75 12.8096 2.88348 8.51741 6.68109 5.35273C10.4787 2.18805 15.6294 0.410156 21 0.410156C26.3706 0.410156 31.5213 2.18805 35.3189 5.35273C39.1165 8.51741 41.25 12.8096 41.25 17.2852Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 22.9102C24.7279 22.9102 27.75 20.3918 27.75 17.2852C27.75 14.1786 24.7279 11.6602 21 11.6602C17.2721 11.6602 14.25 14.1786 14.25 17.2852C14.25 20.3918 17.2721 22.9102 21 22.9102Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="border-dashed border-[#006400] border-2 sm:border-4 self-stretch shrink-0 w-0 relative"></div>
          <div class="p-2.5 flex flex-col gap-2.5 items-center justify-center flex-1 relative">
            <div class="sm:pt-5 sm:pr-[30px] sm:pb-5 sm:pl-[30px] flex flex-col gap-2.5 items-center justify-center self-stretch shrink-0 relative">
              <div class="flex flex-col gap-[5px] sm:gap-[30px] items-center justify-center self-stretch shrink-0 relative">
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                 font-normal relative self-stretch"
                >
                  Course - Android Studio, TEXTRON
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                 font-normal relative"
                >
                  Oct 2022 – Feb 2023
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                 font-normal relative self-stretch"
                >
                  In this course, we studied the development of Android
                  applications and their use in everyday situations. We explored
                  the Java programming language along with XML for defining
                  graphical interfaces and used Android Studio as the integrated
                  development environment. We learned how to work with the
                  sensors available on mobile devices to create interactive and
                  engaging applications.
                </div>
                <div class="shrink-0 w-[45px] h-[45px] relative overflow-hidden">
                  <a href="https://www.textron.com/">
                    <svg
                      class="w-[50%] h-[50%] sm:w-[90%] sm:h-[90%]  absolute right-[5%] left-[5%] bottom-[4.17%] top-[4.17%] overflow-visible"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M41.25 17.2852C41.25 30.4102 21 41.6602 21 41.6602C21 41.6602 0.75 30.4102 0.75 17.2852C0.75 12.8096 2.88348 8.51741 6.68109 5.35273C10.4787 2.18805 15.6294 0.410156 21 0.410156C26.3706 0.410156 31.5213 2.18805 35.3189 5.35273C39.1165 8.51741 41.25 12.8096 41.25 17.2852Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 22.9102C24.7279 22.9102 27.75 20.3918 27.75 17.2852C27.75 14.1786 24.7279 11.6602 21 11.6602C17.2721 11.6602 14.25 14.1786 14.25 17.2852C14.25 20.3918 17.2721 22.9102 21 22.9102Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="sm:pt-5 sm:pr-[30px] sm:pb-5 sm:pl-[30px] flex flex-col gap-2.5 items-center justify-center self-stretch shrink-0 relative">
              <div class="flex flex-col gap-[5px] sm:gap-[30px] items-center justify-center self-stretch shrink-0 relative">
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                 font-normal relative self-stretch"
                >
                  Course - Automatic Testing, ENDAVA
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                 font-normal relative"
                >
                  Jan 2022 – Apr 2022
                </div>
                <div
                  class="text-[#ffffff] text-center font-['Inter-Regular',_sans-serif] text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                 font-normal relative self-stretch"
                >
                  In this course, we have studied programming languages such as
                  Python, Java, and JavaScript, which are widely used in
                  automated testing development. These languages enable the
                  implementation of complex scenarios and functionalities for
                  the automated testing of software applications.
                </div>
                <div class="shrink-0 w-[45px] h-[45px] relative overflow-hidden">
                  <a href="https://www.endava.com/">
                    <svg
                      class="w-[50%] h-[50%] sm:w-[90%] sm:h-[90%] absolute right-[5%] left-[5%] bottom-[4.17%] top-[4.17%] overflow-visible"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M41.25 17.2852C41.25 30.4102 21 41.6602 21 41.6602C21 41.6602 0.75 30.4102 0.75 17.2852C0.75 12.8096 2.88348 8.51741 6.68109 5.35273C10.4787 2.18805 15.6294 0.410156 21 0.410156C26.3706 0.410156 31.5213 2.18805 35.3189 5.35273C39.1165 8.51741 41.25 12.8096 41.25 17.2852Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 22.9102C24.7279 22.9102 27.75 20.3918 27.75 17.2852C27.75 14.1786 24.7279 11.6602 21 11.6602C17.2721 11.6602 14.25 14.1786 14.25 17.2852C14.25 20.3918 17.2721 22.9102 21 22.9102Z"
                        stroke="#006400"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Element>
  );
};

export default Education;
